import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";

export const Header = () => {
  const [paramValue, setParamValue] = useState("/");
  const navigate = useNavigate();

  useEffect(() => {
    const referrer = document.referrer;
    const path = "plans";
    const params = new URLSearchParams(window.location.search);
    const at = params.get("at");

    if (referrer && at) {
      const backURL = referrer + path + "?ut=" + at;
      setParamValue(backURL);
    } else {
      setParamValue("/");
    }
  }, []);

  const goBack = () => {
    if (paramValue && paramValue !== "/") {
      //   navigate(paramValue);
      window.location.href = paramValue;
    } else {
      //   navigate("/", { replace: true });
      window.location.href = "https://www.watcho.com/";
    }
  };

  return (
    //<div className="headerHeight backgroundBlack">
    //    <img src='./Images/Watcho_Logo.png' height="30" width="auto" className="App-logo" alt="logo" />
    //</div>
    <div>
      <nav className="navbar navbar-expand-lg custom-navbar-for-home">
        <div className="container-fluid mobile-res-clss">
          <div className="friendsAndFamilyBackBtn">
            <button onClick={goBack}>
              <img src="./Images/arrow-small-left.png" />
            </button>
          </div>
          <a
            className="navbar-brand custom-logo"
            href="https://www.watcho.com/"
          >
            <img
              src="./Images/logo.svg"
              alt="My Logo"
              className="img-fluid clas-of-logo"
            />
          </a>
        </div>
      </nav>
    </div>
  );
};

//export default Header;
